import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const location = useLocation();

  if (!token) {
    if (location.pathname.startsWith("/employer")) {
      return <Navigate to="/employer/login" replace />;
    }
    return <Navigate to="/jobseeker/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return role === "job_seeker" ? (
      <Navigate to="/jobseeker/dashboard" replace />
    ) : (
      <Navigate to="/employer/dashboard" replace />
    );
  }

  return children;
};

export default ProtectedRoute;